var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261161560"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3923",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#2D2924"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1261161559"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 36C14.4399 36 10.9598 34.9443 7.99974 32.9665C5.03966 30.9886 2.73255 28.1774 1.37017 24.8883C0.00779486 21.5992 -0.348659 17.98 0.345874 14.4884C1.04041 10.9967 2.75474 7.78943 5.27208 5.27209C7.78942 2.75474 10.9967 1.04041 14.4884 0.345872C17.98 -0.348662 21.5992 0.00780229 24.8883 1.37018C28.1774 2.73256 30.9886 5.03967 32.9664 7.99975C34.9443 10.9598 36 14.4399 36 18C35.9948 22.7723 34.0968 27.3477 30.7222 30.7222C27.3477 34.0968 22.7723 35.9948 18 36ZM18 0.92825C14.6235 0.92825 11.3229 1.92949 8.51544 3.80536C5.70801 5.68122 3.51987 8.34746 2.22775 11.4669C0.935632 14.5864 0.59756 18.0189 1.25628 21.3305C1.91499 24.6421 3.54092 27.684 5.92845 30.0716C8.31597 32.4591 11.3579 34.085 14.6695 34.7437C17.9811 35.4025 21.4136 35.0644 24.5331 33.7722C27.6525 32.4801 30.3188 30.292 32.1946 27.4846C34.0705 24.6771 35.0717 21.3765 35.0717 18C35.0666 13.4739 33.2663 9.1346 30.0659 5.93414C26.8654 2.73368 22.5261 0.933404 18 0.92825Z",
    fill: "#C3FCF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.6714 17.9981L13.6671 7.05078L20.3043 17.9981L13.6671 28.9422L28.6714 17.9981Z",
    fill: "#C3FCF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.8599 21.5531C12.8227 21.5531 14.4139 19.962 14.4139 17.9992C14.4139 16.0364 12.8227 14.4453 10.8599 14.4453C8.89717 14.4453 7.30603 16.0364 7.30603 17.9992C7.30603 19.962 8.89717 21.5531 10.8599 21.5531Z",
    fill: "#C3FCF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8599 21.5507C11.8016 21.5507 12.7048 21.1766 13.3706 20.5107C14.0365 19.8448 14.4106 18.9417 14.4106 18H7.30603C7.30603 18.4666 7.39799 18.9285 7.57663 19.3595C7.75527 19.7905 8.01709 20.1821 8.34715 20.5119C8.6772 20.8416 9.069 21.1031 9.50016 21.2813C9.93133 21.4596 10.3934 21.5511 10.8599 21.5507Z",
    fill: "#00C9B0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6671 28.9441L28.6714 18H20.3043L13.6671 28.9441Z",
    fill: "#00C9B0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.670046a23e35907de2b4e82d6c189488.svg";
export { ForwardRef as ReactComponent };